export * from './Tab';
export * from './TabAction';
export * from './Tabs';
export * from './TabContent';
export * from './TabContentBody';
export * from './TabsContext';
export * from './TabTitleText';
export * from './TabTitleIcon';
//# sourceMappingURL=index.js.map